 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import COPYRIGHT from '@/components/copyright'
 import TITLEPAGE from '@/components/title-page'
 import CONTENTS from '@/components/contents'
 import FOREWORD from '@/components/foreword'
 import TOTHREELITTLEKATHARINES from '@/components/to-three-little-katharines'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import CHAPTER009 from '@/components/chapter-009'
 import CHAPTER010 from '@/components/chapter-010'
 import CHAPTER011 from '@/components/chapter-011'
 import EPILOGUE from '@/components/epilogue'
 import LOVE_2 from '@/components/love_2'
 import UPART001 from '@/components/upart-001'
 import UPART001CHAPTER001 from '@/components/upart-001-chapter-001'
 import UPART001CHAPTER002 from '@/components/upart-001-chapter-002'
 import PUBLISHERSNOTE from '@/components/publishers-note'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import ABOUTTHEILLUSTRATOR from '@/components/about-the-illustrator'
 import ABOUTTHEFOREWORDAUTHOR from '@/components/about-the-foreword-author'
 import ABOUTTHEEDITOR from '@/components/about-the-editor'
 import WORDFIRECLASSICS from '@/components/wordfire-classics'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/to-three-little-katharines",
 			"name" : "to-three-little-katharines",
 			"component" : TOTHREELITTLEKATHARINES
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js